// Alle animaties die het dashboard kan afspelen, op één plek.
//
// id     - waar de CSS en de animatielaag naar kijken
// key    - toets waarmee je hem afspeelt (animatielab en dashboard)
// name   - hoe hij in het lab in de lijst staat
// hint   - wanneer hij in het echt te zien is
// ms     - hoe lang hij duurt; daarna ruimt de hook hem op
// target - "seller": licht ook de rij/trede van die verkoper op
// demo   - voorbeeldgegevens voor het handmatig afspelen: een toets en de
//          rondleiding ("alles achter elkaar") gebruiken deze, zodat je ziet
//          wát er verkocht is. play() zelf mengt ze niet mee: bij een echte
//          verkoop hoort alleen te staan wat er echt verkocht is.

import { missedSalesMs } from "./missedSales";

export const animations = [
  {
    id: "sale-splash",
    key: "n",
    name: "Nieuwe verkoop",
    hint: "Het beeld gaat donker: wie, wat en hoeveel",
    // 0,4 donker + de regels erin + staan + 0,5 weg; de tijden in
    // animations.css horen hierbij. Bij een echte verkoop komt de balk
    // (sale-bar) pas als dit weg is, zie saleGroup in hooks/useSaleEvents.js.
    ms: 4500,
    demo: { name: "Ernst", amount: 1495, service: "Managed Cloud Backup" },
  },
  {
    id: "sale-bar",
    key: "1",
    name: "Verkoopbalk",
    hint: "De balk bovenlangs, na de aankondiging",
    // 0,55 vallen + 7 staan + 0,45 omhoog; zie de tijden in
    // animations.css, die horen hierbij.
    ms: 8000,
    demo: { name: "Ernst", amount: 1495, service: "Managed Cloud Backup" },
  },
  {
    id: "row-flash",
    key: "2",
    name: "Rij oplichten",
    hint: "Wijst aan wíe er verkocht heeft",
    ms: 1800,
    target: "seller",
    demo: { name: "Ernst" },
  },
  {
    id: "confetti-burst",
    key: "3",
    name: "Confetti",
    hint: "Grote deal of mijlpaal",
    // Laatste snipper: 1.6s wachten + 4.6s vallen. Korter en de laag
    // verdwijnt terwijl er nog dingen onderin het beeld hangen.
    ms: 6600,
  },
  {
    id: "coin-rain",
    key: "4",
    name: "Muntenregen",
    hint: "Deal vanaf €500",
    // Laatste munt: 1.8s wachten + 3.6s vallen.
    ms: 5800,
  },
  {
    id: "gem-rain",
    key: "g",
    name: "Diamantregen",
    hint: "Deal vanaf €1.000",
    // Laatste diamant: 1.4s wachten + 4.4s vallen.
    ms: 6200,
  },
  {
    id: "rank-up",
    key: "5",
    name: "Stijger",
    hint: "Iemand schuift op in de ranglijst",
    ms: 3600,
    demo: { name: "Ernst", position: 2, from: 4 },
  },
  {
    id: "gauge-pulse",
    key: "6",
    name: "Meter pulseert",
    hint: "Het teamtotaal loopt op",
    ms: 2400,
  },
  {
    id: "screen-glow",
    key: "7",
    name: "Schermrand",
    hint: "Rustig seintje zonder tekst",
    ms: 2600,
  },
  {
    id: "fireworks",
    key: "8",
    name: "Vuurwerk",
    hint: "Grootste losse verkoop ooit",
    // Laatste knal: 1.6s wachten + 1.5s vliegen; de tekst blijft 5.2s staan
    // zodat je hem ook echt kunt lezen.
    ms: 5200,
    demo: {
      name: "Ernst",
      amount: 4250,
      service: "Managed Cloud Backup",
      previous: 3200,
    },
  },
  {
    id: "podium-bounce",
    key: "9",
    name: "Podium veert",
    hint: "De top 3 verandert van volgorde",
    ms: 1800,
  },
  {
    id: "target-hit",
    key: "0",
    name: "Target gehaald",
    hint: "Het team tikt de 100% aan",
    ms: 7000,
    demo: { amount: 85000 },
  },
  {
    id: "missed-sales",
    key: "m",
    name: "Verkopen gemist",
    hint: "Na het aanzetten: wat er verkocht is terwijl de tv uit stond",
    // De kaart somt de verkopen één voor één op, dus hoe lang hij staat
    // hangt af van hoeveel het er zijn: zie msFor. ms is de duur van het
    // voorbeeld hieronder, voor het lab.
    ms: missedSalesMs(3),
    msFor: (payload) => missedSalesMs(payload.sales?.length ?? 0),
    // since: hoe laat het scherm uitging. Vast op gisteravond, zodat de
    // kaart in het lab ook "gisteren" zegt.
    demo: {
      since: Date.now() - 15 * 60 * 60 * 1000,
      amount: 3525,
      sales: [
        { name: "Ernst", amount: 1495, service: "Managed Cloud Backup" },
        { name: "Bert", amount: 1250, service: "Microsoft 365" },
        { name: "Hans", amount: 780, service: "Werkplekbeheer" },
      ],
    },
  },
];

// Hoe lang een run duurt. Meestal gewoon ms; een animatie die langer staat
// naarmate er meer op staat (de kaart "Verkopen gemist") rekent dat uit met
// msFor op basis van wat hij te zien krijgt.
export const durationOf = (animation, payload = {}) =>
  animation.msFor ? animation.msFor(payload) : animation.ms;

export const byId = (id) => animations.find((a) => a.id === id) || null;
export const byKey = (key) => animations.find((a) => a.key === key) || null;
